import * as React from 'react';
import {
    List,
    EditButton,
    Datagrid,
    TextField, DateField, ReferenceField,
    Filter,
    TextInput,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search by Name" source="name" alwaysOn />
        <TextInput label="Search by Title" source="title" alwaysOn />
    </Filter>
);

const CampaignList = () => {
    const { isUpdatable, isDeletable, isWritable } = useIsPermission("CAMPAIGNS");
    return (
        <div>
            <List
                filters={<ListFilter />}
                actions={<PermissionBasedActions isWritable={isWritable} />}
                queryOptions={{
                    refetchOnReconnect: false,
                    refetchOnWindowFocus: false,
                }}
            >
                <Datagrid >
                    <TextField source="name" sortable={false} />
                    <TextField source="title" sortable={false} />
                    <TextField source="message" sortable={false} />
                    <TextField source="segment.name" label="Segment" />
                    <DateField source="startsAt" sortable={false} />
                    <FormattedDateTimeField source="createdAt" sortable={false} />
                    {isUpdatable &&
                        <EditButton />
                    }
                    {isDeletable &&
                        <ConfirmDeleteButton />
                    }
                </Datagrid>
            </List>
        </div>
    );
};
export default CampaignList;
